import React from "react";
import { Modal, Button } from "@mui/material";
import { IoArrowBack } from "react-icons/io5";
import { MdOutlineDragHandle } from "react-icons/md";
import { ReactSortable } from "react-sortablejs";
import Spinner from "../spinner";

function ProductRearrangementModal({
  open,
  onClose,
  products,
  isLoading,
  isSaving,
  onSave,
  onOrderChange,
}) {
  // Unique ID for the sortable list
  const sortableId = "product-rearrange-list";

  return (
    <Modal
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick" && !isSaving) {
          onClose();
        }
      }}
      disableEscapeKeyDown={true}
      aria-labelledby="rearrangement-modal-title"
      aria-describedby="rearrangement-modal-description"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className="w-full sm:w-11/12 md:w-10/12 lg:w-9/12 xl:w-8/12 max-w-5xl mx-auto bg-white rounded-md flex flex-col max-h-[90vh]">
        <div className="head-modal py-3 px-4 sm:px-6 border-b">
          <div className="flex items-center space-x-4">
            <div className="w-7 h-7 cursor-pointer" onClick={onClose}>
              <IoArrowBack className="w-full h-full" />
            </div>
            <h2 className="heading text-xl sm:text-2xl truncate">
              Rearrange Products
            </h2>
          </div>
        </div>

        <div className="body-modal py-4 px-4 sm:px-6 flex-1 overflow-y-auto">
          {isLoading ? (
            <div className="flex justify-center py-10">
              <Spinner />
            </div>
          ) : products.length === 0 ? (
            <div className="text-center py-10">
              <p className="text-gray-500">
                No products available to rearrange
              </p>
            </div>
          ) : (
            <div className="space-y-2">
              <p className="text-sm text-gray-500 mb-4">
                Drag and drop products to change their display order. Changes
                will be saved when you click "Save Order".
              </p>

              <ReactSortable
                list={products}
                setList={onOrderChange}
                animation={200}
                delayOnTouchOnly={true}
                delay={2}
                id={sortableId}
                className="space-y-2"
                idPath="product_id"
              >
                {products.map((product, index) => (
                  <div
                    key={product.product_id}
                    className="bg-white border rounded-lg p-3 flex items-center gap-4 cursor-move hover:shadow-md transition-shadow"
                  >
                    <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 text-gray-500 font-semibold">
                      {index + 1}
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="font-medium">
                        {product.name}
                      </p>
                      {/* <p className="text-sm text-gray-500">
                        ID: {product.product_id}
                      </p> */}
                    </div>
                    <div className="flex-shrink-0 w-8 text-gray-400">
                      <MdOutlineDragHandle className="h-6 w-6" />
                    </div>
                  </div>
                ))}
              </ReactSortable>
            </div>
          )}
        </div>

        <div className="py-4 text-center flex space-x-4 justify-center border-t">
          <Button
            variant="contained"
            className="primaryBtn-contained px-8 sm:px-10 mr-4 sm:mr-6"
            onClick={onSave}
            disabled={isLoading || isSaving || products.length === 0}
          >
            {isSaving ? "Saving..." : "Save Order"}
          </Button>
          <Button
            variant="outlined"
            className="primaryBtn-outlined px-8 sm:px-10"
            onClick={onClose}
            disabled={isSaving}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default ProductRearrangementModal;
